import React, { Component } from 'react';
import * as securityPost from './SecurityPost';
import { API_HOST } from './constants';

class PlayerStream extends Component {
    constructor(props) {
        super(props);
        this.wasPlayingOnBlur = false;
        this.lastSelectedChannel = null;
        this.handlePageBlur = this.handlePageBlur.bind(this);
        this.handlePageFocus = this.handlePageFocus.bind(this);
    }

    componentDidMount() {
        //Loadplayer
        this.player = window.player = window.videojs('true-tv-player');
        this.player.trueTv({});

        window.addEventListener('blur', this.handlePageBlur, false);
        window.addEventListener('focus', this.handlePageFocus, false);
    }

    componentWillUnmount() {
        window.removeEventListener('blur', this.handlePageBlur, false);
        window.removeEventListener('focus', this.handlePageFocus, false);
    }

    handlePageBlur() {
        this.wasPlayingOnBlur = !this.player.paused();
    }

    handlePageFocus() {
        this.getUrlStream(this.lastSelectedChannel, this.wasPlayingOnBlur);
    }

    getUrlStream(selectChannel, shouldPlayOnLoad = true) {

        if(selectChannel === null){
            selectChannel = this.props.defaultchannel;
        }
        this.lastSelectedChannel = selectChannel;
        securityPost.Encrypt(selectChannel).then((reslove, reject) => {
            fetch(`${API_HOST}/stream/provider`, reslove)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    else {
                        throw new Error(`${response.status}-${response.statusText}`);
                    }
                }).then(response => {
                    this.player.pause();
                    this.configSourcePlayer(selectChannel, response.result);

                    // NOTE: Ineffective with the video `autoPlay` attribute.
                    if (shouldPlayOnLoad) {
                        this.player.play();
                    }
                }).catch(err => {
                    console.log(err);
                });
        });
    }

    configSourcePlayer(selectChannel, src) {
        this.player.src({
            src,
            type: "application/x-mpegURL",
            info: {
                title: selectChannel.channelname,
                description: selectChannel.channelname,
                icon: selectChannel.img
            },
            watermark: {
                src: "/assets/trueplayer/img/logooverlay-truetv.png",
                href: "http://worldcup.trueid.net"
            },
            embed: {
                url: window.location.href,
            },
            analytics: {
                mux: {
                    debug: false,
                    data: {
                        property_key: "24178227f9e3310f8b5347d85",
                        page_type: "watchpage",
                        viewer_user_id: "",
                        experiment_name: "http://worldcup.trueid.net/",
                        sub_property_id: "prod",
                        player_name: `worldcup / ${selectChannel.channel}`,
                        player_version: "0.4.4",
                        player_init_time: "",
                        video_id: selectChannel.code,
                        video_title: selectChannel.channelname,
                        video_series: selectChannel.channel,
                        video_producer: selectChannel.channelname,
                        video_content_type: "stream",
                        video_language_code: "en",
                        video_variant_name: "",
                        video_variant_id: "",
                        video_duration: "",
                        video_stream_type: "live",
                        video_encoding_variant: "",
                        video_cdn: "StreamingProvider"
                    }
                }
            }
        });

    };

    render() {
        return (
            <video
                id="true-tv-player"
                className="video-js vjs-16-9 vjs-default-skin"
                width="100%"
                height="100%"
                controls
                playsInline
            ></video>
        );
    };
}

export default PlayerStream;



// WEBPACK FOOTER //
// ./src/PlayerStream.js